(function(){
  var root  = document.getElementById('uh');
  if(!root) return;
  var calm  = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- split the headline into per-letter masks ----------
     Done here rather than in Liquid: Shopify's `split: ''` returns an
     empty array, not a list of characters. Doing it in JS also means the
     headline is plain readable text until this runs. */
  [].slice.call(root.querySelectorAll('[data-split]')).forEach(function(el){
    var text = (el.textContent || '').trim();
    if(!text) return;
    el.textContent = '';
    text.split('').forEach(function(ch){
      var mask = document.createElement('span');
      mask.className = 'uh-ltr';
      var glyph = document.createElement('i');
      glyph.textContent = (ch === ' ') ? '\u00a0' : ch;
      mask.appendChild(glyph);
      el.appendChild(mask);
    });
  });

  /* ---------- page-load type assembly ---------- */
  var ltrs = root.querySelectorAll('.uh-ltr i');
  ltrs.forEach(function(el,i){ el.style.transitionDelay = (i*70)+'ms'; });
  requestAnimationFrame(function(){
    requestAnimationFrame(function(){ root.classList.add('is-live'); });
  });

  /* ---------- hero letters react to the pointer ---------- */
  var word = document.getElementById('uh-word');
  if(word && !calm && window.matchMedia('(pointer:fine)').matches){
    var spans = [].slice.call(word.querySelectorAll('.uh-ltr i'));
    var raf = null, mx = 0, my = 0;
    window.addEventListener('mousemove', function(e){
      mx = e.clientX; my = e.clientY;
      if(raf) return;
      raf = requestAnimationFrame(function(){
        raf = null;
        // letters only lift once they've finished seating in
        if(!root.classList.contains('is-live')) return;
        spans.forEach(function(s){
          var r = s.getBoundingClientRect();
          var dx = mx - (r.left + r.width/2);
          var dy = my - (r.top  + r.height/2);
          var d  = Math.sqrt(dx*dx + dy*dy);
          var f  = Math.max(0, 1 - d/460);
          s.style.transitionDelay = '0ms';
          s.style.transitionDuration = '520ms';
          s.style.transform = 'translateY(' + (-16*f).toFixed(2) + 'px) rotate(' + (dx/r.width*-1.6*f).toFixed(2) + 'deg)';
        });
      });
    }, {passive:true});
  }

  /* ---------- marquee: base drift + scroll velocity ---------- */
  var rows = [].slice.call(document.querySelectorAll('.uh-mq-row'));
  if(rows.length && !calm){
    var state = rows.map(function(r){ return {el:r, dir:parseFloat(r.dataset.mq), x:0, w:0}; });
    var measure = function(){
      state.forEach(function(s){ s.w = s.el.firstElementChild.offsetWidth; });
    };
    measure();
    window.addEventListener('resize', measure);

    var lastY = window.scrollY, vel = 0;
    window.addEventListener('scroll', function(){
      vel = window.scrollY - lastY; lastY = window.scrollY;
    }, {passive:true});

    (function tick(){
      vel *= 0.9;
      state.forEach(function(s){
        s.x -= s.dir * (0.55 + vel * 0.16);
        if(s.w){
          if(s.x <= -s.w) s.x += s.w;
          if(s.x >= 0)    s.x -= s.w;
        }
        var skew = Math.max(-7, Math.min(7, -vel * 0.28 * s.dir));
        s.el.style.transform = 'translate3d(' + s.x.toFixed(2) + 'px,0,0) skewX(' + skew.toFixed(2) + 'deg)';
      });
      requestAnimationFrame(tick);
    })();
  }

  /* ---------- reveal on scroll ---------- */
  var rise = document.querySelectorAll('.uh-rise');
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, {rootMargin:'0px 0px -12% 0px', threshold:.12});
    rise.forEach(function(el){ io.observe(el); });
  } else {
    rise.forEach(function(el){ el.classList.add('is-in'); });
  }

  /* ---------- wayfinding: sticky bar, progress, active world ---------- */
  var bar    = document.getElementById('uh-bar');
  var prog   = document.getElementById('uh-prog');
  var links  = [].slice.call(document.querySelectorAll('#uh-nav a, #uh-chips a'));
  var chips  = document.getElementById('uh-chips');
  var worlds = ['gaming','workstations','business','repairs','refurbished']
                 .map(function(id){ return document.getElementById(id); })
                 .filter(Boolean);
  var current = '';

  function setActive(id){
    if(id === current) return;
    current = id;
    links.forEach(function(a){
      var on = a.getAttribute('href') === '#' + id;
      a.classList.toggle('is-here', on);
      if(on && chips && chips.offsetParent !== null && a.parentNode === chips){
        chips.scrollTo({ left: Math.max(0, a.offsetLeft - 20), behavior: calm ? 'auto' : 'smooth' });
      }
    });
  }

  function onScroll(){
    if(!bar || !prog) return;
    var y = window.scrollY;
    bar.classList.toggle('is-stuck', y > 40);

    var max = document.documentElement.scrollHeight - window.innerHeight;
    prog.style.width = (max > 0 ? Math.min(100, (y/max)*100) : 0) + '%';

    var mid = y + window.innerHeight * 0.4, found = '';
    worlds.forEach(function(s){
      if(s.offsetTop <= mid) found = s.id;
    });
    setActive(found);
  }
  window.addEventListener('scroll', onScroll, {passive:true});
  window.addEventListener('resize', onScroll);
  onScroll();

  /* ---------- repairs diagnostic ----------

     The panel is filled from each button's own data attributes, which the
     section writes out of the Repair symptom blocks.

     This used to read from a copy of the five original symptoms hardcoded
     in this file and indexed by position, which is why editing a block
     changed its label in the list and nothing else: the label came from
     Liquid, the panel came from JavaScript, and the two had no connection.
     It also capped the section at five — a sixth block indexed past the end
     of the array and rendered an empty panel.

     Reading the dataset means the block content is the only source, there
     is no limit on how many symptoms there can be, and nothing in here
     needs editing when the copy changes. */
  var symp = document.getElementById('uh-symp');
  var swap = document.getElementById('uh-swap');
  if(symp && swap){
    var btns = [].slice.call(symp.querySelectorAll('button'));
    var FIELDS = ['tag','h','p','t'];

    var render = function(btn, instant){
      if(!btn) return;
      var write = function(){
        FIELDS.forEach(function(k){
          var el = swap.querySelector('[data-f="'+k+'"]');
          if(!el) return;
          var v = btn.dataset[k] || '';
          el.textContent = v;
          // A block with an empty field shouldn't leave a gap where the
          // line would have been.
          el.style.display = v ? '' : 'none';
        });
        swap.classList.remove('is-out');
      };
      // The fade is for a swap between two symptoms. On first paint there
      // is nothing to fade out of, so it would just delay the content.
      if(instant || calm){ write(); return; }
      swap.classList.add('is-out');
      setTimeout(write, 260);
    };

    btns.forEach(function(b){
      b.addEventListener('click', function(){
        btns.forEach(function(o){ o.setAttribute('aria-selected','false'); });
        b.setAttribute('aria-selected','true');
        render(b);
      });
      b.addEventListener('mouseenter', function(){
        if(window.matchMedia('(pointer:fine)').matches) b.click();
      });
    });

    // keyboard: up/down through the symptom list
    symp.addEventListener('keydown', function(e){
      var i = btns.indexOf(document.activeElement);
      if(i < 0) return;
      if(e.key === 'ArrowDown' || e.key === 'ArrowUp'){
        e.preventDefault();
        var n = (i + (e.key === 'ArrowDown' ? 1 : -1) + btns.length) % btns.length;
        btns[n].focus(); btns[n].click();
      }
    });

    // Paint whichever symptom the section marked as selected. The panel
    // used to sit empty until the first hover or click.
    var initial = btns.filter(function(b){
      return b.getAttribute('aria-selected') === 'true';
    })[0] || btns[0];
    render(initial, true);
  }

  /* ---------- click measurement ----------

     Links that matter carry data-uh-track (hero_explore, hero_core,
     hero_custom, world_play ... world_reuse). Each click goes to the
     Clarity already on every page as a custom event, and is published
     to Shopify customer events for any pixel that wants it later. Both
     calls are guarded: if either is missing, the link still just works. */
  root.addEventListener('click', function(e){
    var a = e.target && e.target.closest ? e.target.closest('[data-uh-track]') : null;
    if(!a) return;
    var name = a.getAttribute('data-uh-track');
    try{ if(typeof window.clarity === 'function') window.clarity('event', name); }catch(err){}
    try{
      if(window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function'){
        Shopify.analytics.publish('uh_click', { name: name, href: a.getAttribute('href') || '' });
      }
    }catch(err){}
  });
})();